import { render, staticRenderFns } from "./major.vue?vue&type=template&id=35140739&scoped=true"
import script from "./major.vue?vue&type=script&lang=js"
export * from "./major.vue?vue&type=script&lang=js"
import style0 from "./major.vue?vue&type=style&index=0&id=35140739&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35140739",
  null
  
)

export default component.exports